<template>

  <div id="hubspot-wrapper">

    <el-tabs v-model="activeTab" type="border-card" class="hubspot-tabs">
      <el-tab-pane name="dialer">
        <template slot="label">
          <v-svg class="voxo-blue" sprite="keypad" />
        </template>
        <dialer type="hubspot" />
      </el-tab-pane>
      <el-tab-pane name="contacts">
        <template slot="label">
          <v-svg class="voxo-green" sprite="user" />
        </template>
        <contacts-view />
      </el-tab-pane>
      <el-tab-pane name="queues">
        <template slot="label">
          <v-svg class="voxo-purple" sprite="group-4" />
        </template>
        <queues />
      </el-tab-pane>
      <el-tab-pane name="recent">
        <template slot="label" >
          <v-svg class="voxo-pink" sprite="books" />
        </template>
        <recent-activity />
      </el-tab-pane>
      <el-tab-pane name="settings">
        <template slot="label">
          <v-svg class="voxo-aqua" sprite="gear" />
        </template>
        <settings />
      </el-tab-pane>
    </el-tabs>
  </div>

</template>

<script>

import ContactsView from './tabs/contacts/view';
import Dialer from './tabs/dialer/view';
import Queues from './tabs/queues/view';
import RecentActivity from './tabs/recent-calls/view';
import Settings from './tabs/settings/view';
import moment from 'moment-timezone';
import {globalEventBus} from "@/globalEventBus";

//Hubspot SDKs
import CallingExtensions from '@hubspot/calling-extensions-sdk';
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: 'HubspotIntegration',
  components: {
    Dialer,
    ContactsView,
    Queues,
    RecentActivity,
    Settings
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    softphoneEnabled(){
      return this.$store.state.softphoneEnabled;
    }
  },
  data() {
    return {
      activeTab: 'dialer',
      callingExten: null,
      engagementId: null
    }
  },
  methods: {

    handleClickToDial(data) {
      const {phoneNumber} = data;
      globalEventBus.$emit('hubspotClickToDial', phoneNumber);
      this.activeTab = 'dialer';

      //notify hubspot and create engagement
      this.callingExten.outgoingCall({
        phoneNumber: phoneNumber,
        createEngagement: true
      });
    },

    numberFormatter(number) {
      return number
        ? phoneNumberFormatter(number)
        : number;
    },

    initCallingExten(){

      this.callingExten = new CallingExtensions({
        debugMode: true,
        eventHandlers: {
          onReady: () => {
            console.log('got the ready callback from hubspot!');
          },
          onDialNumber: (event) => {
            console.log('got a on dial number event', event);
            this.handleClickToDial(event);
          },
          onEngagementCreated: (data) => {
            console.log('an engagement was created here is the data', data);
            this.engagementId = data.engagementId
          },
          onVisibilityChanged: (data) => {
            console.log('visibility changed!');
          }
        }
      });
    }

  },
  created() {

    //Softphone Event Listeners
    globalEventBus.$on('globalCallHangup', data => {
      console.log('this call hung up', data);
      this.callingExten.callEnded();
      this.callingExten.callCompleted({
        engagementId: this.engagementId,
        hideWidget: false
      });
    });

  },
  mounted() {

    //force light mode
    document.body.setAttribute('class', 'theme-default');

    //Init CallingExtensionsSDK
    this.initCallingExten();

  }
}

</script>



<style lang="scss">

#hubspot-wrapper {
  max-width: 450px;
}

.hubspot-tabs{
  display: flex;
  flex-direction: column-reverse;
  .el-tab-pane{
    height: 433px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .el-tabs__item {
    line-height: 48px;
  }

  .el-tabs__content{
    padding: 5px;
  }

  .current-call-item{
    margin-left: 0;
  }
}

@media(max-width: 768px) {
  #hubspot-wrapper.view {
    padding: 0;
  }
}

</style>
